export default __webpack_public_path__ + "static/media/fogs-fond-logo.5e8e7946.svg";